import * as THREE from 'three';

const DROPS = 1600;
const BOX = 56; // metres: the rain is drawn in a box this wide around the camera
const TALL = 34;

// Rain falling around the camera whenever the real weather says it is raining.
export class Rain {
  constructor(scene) {
    this.local = new Float32Array(DROPS * 3); // each drop's place in the box
    for (let i = 0; i < DROPS; i++) {
      this.local[i * 3] = (Math.random() - 0.5) * BOX;
      this.local[i * 3 + 1] = Math.random() * TALL;
      this.local[i * 3 + 2] = (Math.random() - 0.5) * BOX;
    }
    this.positions = new Float32Array(DROPS * 6); // a short streak per drop: two points
    const g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.BufferAttribute(this.positions, 3));
    this.material = new THREE.LineBasicMaterial({ color: 0xd4dde6, transparent: true, opacity: 0.4, depthWrite: false });
    this.lines = new THREE.LineSegments(g, this.material);
    this.lines.frustumCulled = false;
    this.lines.visible = false;
    scene.add(this.lines);
  }

  // amount: 0 dry to 1 a downpour. camera: where the viewer is.
  update(dt, camera, amount) {
    if (amount < 0.04) {
      this.lines.visible = false;
      return;
    }
    this.lines.visible = true;
    const n = Math.floor(DROPS * Math.min(1, 0.25 + amount));
    const fall = 17 + amount * 9; // metres per second
    const slant = 2.2; // the wind pushes it a little
    const streak = 0.5 + amount * 0.5;
    const c = camera.position;
    const p = this.positions;
    const l = this.local;
    for (let i = 0; i < n; i++) {
      const k = i * 3;
      l[k + 1] -= fall * dt;
      l[k] += slant * dt;
      if (l[k + 1] < 0) l[k + 1] += TALL;
      if (l[k] > BOX / 2) l[k] -= BOX;
      const x = c.x + l[k];
      const y = c.y - TALL * 0.45 + l[k + 1];
      const z = c.z + l[k + 2];
      const j = i * 6;
      p[j] = x;
      p[j + 1] = y;
      p[j + 2] = z;
      p[j + 3] = x - slant * 0.03 * streak;
      p[j + 4] = y + streak;
      p[j + 5] = z;
    }
    this.lines.geometry.setDrawRange(0, n * 2);
    this.lines.geometry.attributes.position.needsUpdate = true;
    this.material.opacity = 0.25 + amount * 0.3;
  }
}
